class printParamsCtrl {
  constructor($scope, httpRequest, $uibModal, openedInvoiceService, logger, $timeout) {
    let init = function () {
      httpRequest.post_getInvoicePrintConfPage({}).then(res => {
        $scope.listData = res.data.value.slice()
      })
    }
    init()
    let mngType0PrinterList = []
    if ($scope.soapStatus == 3) {
      openedInvoiceService.getPrinterNameList({}).then((res) => {
        if (!res.list) logger.logError(res.retmsg)
        mngType0PrinterList = res.list.slice()
      }, () => {
        logger.logError('获取打印机列表失败')
      })
    }
    $scope.printHelperParam = JSON.parse(localStorage.getItem("printHelperParam"))
    let setPrinterList = function (item, scope) {
      if (item.mngType === '0') {
        scope.printerList = mngType0PrinterList
        scope.printer = item.printerName || scope.printerList[0]
      }
      
      if (item.mngType === '2') {
        scope.printerList = $scope.printHelperParam.printerlist.reduce((total, curr) => {
          if (curr.default === "1") {
            scope.printer = curr.name
          }
          total.push(curr.name)
          return total
        }, [])
        if (item.printerName) {
          scope.printer = item.printerName
        }
      }
    }
    $scope.settingHandle = function (item) {
      if (item.mngType === '0' && $scope.soapStatus != 3) {
        logger.logTips("请启动SOAP，获取打印机设备！", 'warn')
        return
      }
      if (item.mngType === '2' && !$scope.printHelperParam.printHelperIsConnect) {
        logger.logTips("请启动打印助手，获取打印机设备！", 'warn')
        return
      }
      $uibModal.open({
        templateUrl: 'editPrintParams.html',
        openedClass: 'mod-modal mod-modal-md modal-print-params-container',
        animation: true,
        controller: ['$scope', 'obj', '$uibModalInstance', 'logger', 'httpRequest', function ($scope, obj, $uibModalInstance, logger, httpRequest) {
          $scope.item = { ...obj.item }
          setPrinterList(obj.item, $scope)
          $scope.submiting = false
          $scope.cancel = function cancel () {
            $uibModalInstance.dismiss()
          }
          function checkNum (v) {
            if (v === 0) {
              return true
            }
            if (Math.abs(v) > 0) {
              return true
            } else {
              return false
            }
          }
          $scope.ok = function ok () {
            $scope.submiting = true
            if (!checkNum(+$scope.item.printDown)) {
              logger.logError('向下调整参数不合法')
              $scope.submiting = false
              return
            }
            if (!checkNum(+$scope.item.printRight)) {
              logger.logError('向右调整参数不合法')
              $scope.submiting = false
              return
            }
            
            $scope.item.mngType === '0' && Promise.all([openedInvoiceService.setPrinterName({
              printerKindName: $scope.item.key,
              printerName: $scope.printer,
            }), openedInvoiceService.setPrinterParams({
              printerKindName: $scope.item.key,
              printerName: $scope.printer,
              printLeft: $scope.item.right * -1,
              printTop: $scope.item.down * -1
            })]).then((result) => {
              let errorMsg = ''
              if (result[0].retcode == 1 && result[1].retcode == 1) {
                logger.logSuccess('保存设置成功')
                httpRequest.post_saveInvoicePrintConfPage({
                  ...$scope.item,
                  printerName: $scope.printer
                }).then(() => {
                  $scope.submiting = false
                  $uibModalInstance.dismiss()
                })
                return
              }
              if (result[0].retcode != 1) {
                errorMsg += result[0].retmsg || '打印机设置失败'
              } else {
                errorMsg += '打印机设置成功'
              }
              if (result[1].retcode != 1) {
                errorMsg += result[1].retmsg || '打印偏移参数设置失败'
              } else {
                errorMsg += '打印偏移参数设置成功'
              }
              logger.logError(errorMsg)
              $scope.submiting = false
              $uibModalInstance.dismiss()
            }).catch(error => {
              console.log(error)
              $scope.submiting = false
              $uibModalInstance.dismiss()
            })

            if ($scope.item.mngType === '2') {
              httpRequest.post_saveInvoicePrintConfPage({
                ...$scope.item,
                printerName: $scope.printer
              }).then(() => {
                let printHelperParamTmp = JSON.parse(localStorage.getItem("printHelperParam"))
                printHelperParamTmp.currSelPrinterName = $scope.printer
                localStorage.setItem('printHelperParam', JSON.stringify(printHelperParamTmp))
              }).finally(() => {
                init()
                $scope.submiting = false
                $uibModalInstance.dismiss()
              })
            }
          }
        }],
        resolve: {
          obj () {
            return {
              item
            }
          },
        }
      }).result.then((type) => {
        init()
      }, () => { })
    }
  }
}

printParamsCtrl.$inject = ['$scope', 'httpRequest', '$uibModal', 'openedInvoiceService', 'logger', '$timeout']
export default printParamsCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/printParams/printParamsCtrl.js